import { render, staticRenderFns } from "./BillHoldList.vue?vue&type=template&id=90ca92a0&"
import script from "./BillHoldList.vue?vue&type=script&lang=js&"
export * from "./BillHoldList.vue?vue&type=script&lang=js&"
import style0 from "./BillHoldList.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPullToRefresh,QBtnToggle,QBtn,QIcon,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPullToRefresh,QBtnToggle,QBtn,QIcon,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd})
